import React, { useEffect, useState, useRef } from 'react';
import './index.css';
import Title from '../Title/Index';
import { TextField, Box } from '@mui/material';
import Fill from '../Button/Fill/Index';

  const BusinessEnquiry = ({ layout = 'default', titleStyle, formStyle, source = 'footer' }) => {
  const [isScroll, setIsScroll] = useState(false);
  const targetSectionRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsScroll(window.scrollY > 800);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToSection = () => {
    if (targetSectionRef.current) {
      targetSectionRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  const [formValues, setFormValues] = useState({
    name: '',
    email: '',
    phone: '',
  });

  const [loading, setLoading] = useState(false); // Loading state

  const LP_NAME = 'sscamasa';
  const SUBMIT_URL = 'https://triverseadvertising.com/ss-group/admin_new/api/lp_submit.php';
  const VERIFY_OTP_URL =
    'https://triverseadvertising.com/ss-group/admin_new/api/lp_verify_otp.php';
  const RESEND_OTP_URL =
    'https://triverseadvertising.com/ss-group/admin_new/api/lp_check_token.php';

  const [submitError, setSubmitError] = useState('');

  const [isOtpStep, setIsOtpStep] = useState(false);
  const [token, setToken] = useState('');

  const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);
  const [otpValues, setOtpValues] = useState(['', '', '', '']);
  const [otpError, setOtpError] = useState('');

  const [resendCountdown, setResendCountdown] = useState(60);
  const [resendWaitMessage, setResendWaitMessage] = useState('');
  const [isResendingOtp, setIsResendingOtp] = useState(false);

  const otpInput0Ref = useRef(null);
  const otpInput1Ref = useRef(null);
  const otpInput2Ref = useRef(null);
  const otpInput3Ref = useRef(null);

  const handleChange = (event) => {
    const { name, value } = event.target;

    if (name === 'name') {
      const regex = /^[A-Za-z\s]*$/;
      if (regex.test(value) || value === '') {
        setFormValues({ ...formValues, [name]: value });
      }
    } else if (name === 'phone') {
      const numericValue = value.replace(/[^0-9]/g, '');
      if (numericValue.length <= 10) {
        setFormValues({ ...formValues, [name]: numericValue });
      }
    } else {
      setFormValues({ ...formValues, [name]: value });
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitError('');
    setOtpError('');

    const fullName = (formValues.name || '').trim();
    const phoneDigits = (formValues.phone || '').replace(/[^0-9]/g, '');
    const email = (formValues.email || '').trim();

    if (!fullName) {
      setSubmitError('Please enter your full name.');
      return;
    }

    if (!/^\d{10}$/.test(phoneDigits)) {
      setSubmitError('Please enter a valid 10-digit mobile number.');
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setSubmitError('Please enter a valid email address.');
      return;
    }

    setLoading(true);
    // 🔥 DATA LAYER EVENT
window.dataLayer = window.dataLayer || [];
window.dataLayer.push({
  event: source === 'header'
    ? 'sscamasa_enquiry_submit_button_header'
    : 'sscamasa_enquiry_submit_button_footer',
  form_name: 'business_enquiry',
  page_path: window.location.pathname,
  lp_name: 'sscamasa'
});
    try {
      let lpUtms = {};
      try {
        lpUtms = JSON.parse(sessionStorage.getItem('lp_utms') || '{}');
      } catch (e) {
        lpUtms = {};
      }

      const payload = {
        name: fullName,
        phone: phoneDigits,
        email,
        lp_name: LP_NAME,
        url: window.location.href,
        utm_source: lpUtms.utm_source || '',
        utm_medium: lpUtms.utm_medium || '',
        utm_campaign: lpUtms.utm_campaign || '',
        utm_term: lpUtms.utm_term || '',
        utm_content: lpUtms.utm_content || '',
        fbclid: lpUtms.fbclid || '',
        fbp: lpUtms.fbp || '',
        fbc: lpUtms.fbc || '',
        gclid: lpUtms.gclid || '',
        gad_source: lpUtms.gad_source || ''
      };

      const res = await fetch(SUBMIT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const data = await res.json().catch(() => ({}));

      if (data?.success === true) {
        setToken(data.token || '');
        setIsOtpStep(true);
        setOtpValues(['', '', '', '']);
        otpInput0Ref.current?.focus?.();
      } else {
        setSubmitError(data?.message || 'Something went wrong. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting form data:', error);
      setSubmitError('There was an error submitting the form. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const readCookie = (name) => {
    if (typeof document === 'undefined') return '';
    const cookies = document.cookie ? document.cookie.split('; ') : [];
    const found = cookies.find((c) => c.startsWith(`${name}=`));
    return found ? decodeURIComponent(found.split('=')[1] || '') : '';
  };

  useEffect(() => {
    // Capture URL + cookie tracking on page load.
    const params = new URLSearchParams(window.location.search);
    const utms = {
      utm_source: params.get('utm_source') || '',
      utm_medium: params.get('utm_medium') || '',
      utm_campaign: params.get('utm_campaign') || '',
      utm_term: params.get('utm_term') || '',
      utm_content: params.get('utm_content') || '',
      fbclid: params.get('fbclid') || '',
      gclid: params.get('gclid') || '',
      gad_source: params.get('gad_source') || '',
      fbp: readCookie('_fbp') || '',
      fbc: readCookie('_fbc') || ''
    };

    try {
      sessionStorage.setItem('lp_utms', JSON.stringify(utms));
    } catch (e) {
      // Ignore storage errors (e.g., blocked storage).
    }
  }, []);

  useEffect(() => {
    if (!isOtpStep) return;
    // OTP step: start resend countdown at 60s.
    setResendCountdown(60);
    setResendWaitMessage('');
  }, [isOtpStep]);

  useEffect(() => {
    if (!isOtpStep) return;
    if (resendCountdown <= 0) return;

    const id = setInterval(() => {
      setResendCountdown((s) => Math.max(0, s - 1));
    }, 1000);

    return () => clearInterval(id);
  }, [isOtpStep, resendCountdown]);

  useEffect(() => {
    if (isOtpStep && resendCountdown === 0) {
      setResendWaitMessage('');
    }
  }, [isOtpStep, resendCountdown]);

  useEffect(() => {
    if (!isOtpStep) return;
    otpInput0Ref.current?.focus?.();
  }, [isOtpStep]);

  const focusOtpFirst = () => {
    otpInput0Ref.current?.focus?.();
  };

  const handleOtpDigitChange = (index, e) => {
    const digit = (e.target.value || '').replace(/[^0-9]/g, '').slice(-1);

    if (otpError) setOtpError('');

    setOtpValues((prev) => {
      const next = [...prev];
      next[index] = digit;
      return next;
    });

    if (digit && index < 3) {
      const nextRef =
        index === 0
          ? otpInput1Ref
          : index === 1
            ? otpInput2Ref
            : otpInput3Ref;
      nextRef.current?.focus?.();
    }
  };

  const handleOtpKeyDown = (index, e) => {
    if (e.key !== 'Backspace') return;
    if (otpValues[index]) return; // Let default delete happen when there is a value.
    if (index === 0) return;

    const prevIndex = index - 1;
    const prevRef =
      prevIndex === 0 ? otpInput0Ref : prevIndex === 1 ? otpInput1Ref : otpInput2Ref;

    // Backspace on an empty box moves focus to the previous digit (and clears it).
    setOtpValues((prev) => {
      const next = [...prev];
      next[prevIndex] = '';
      return next;
    });
    prevRef.current?.focus?.();
  };

  const handleOtpPaste = (e) => {
    e.preventDefault();

    const text = e.clipboardData?.getData('text') || '';
    const digits = text.replace(/[^0-9]/g, '').slice(0, 4).split('');

    if (!digits.length) return;

    const next = ['', '', '', ''];
    for (let i = 0; i < 4; i++) {
      next[i] = digits[i] || '';
    }

    if (otpError) setOtpError('');
    setOtpValues(next);

    // Focus the last filled input (or the first one if only 1 digit was pasted).
    const lastIndex = Math.min(digits.length - 1, 3);
    const ref =
      lastIndex === 0
        ? otpInput0Ref
        : lastIndex === 1
          ? otpInput1Ref
          : lastIndex === 2
            ? otpInput2Ref
            : otpInput3Ref;
    ref.current?.focus?.();
  };

  const handleVerifyOtp = async () => {
    if (isVerifyingOtp) return;
    setIsVerifyingOtp(true);
    setOtpError('');

    const otp = otpValues.join('');
    try {
      const res = await fetch(VERIFY_OTP_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, otp })
      });

      const data = await res.json().catch(() => ({}));

      if (data?.success === true) {
        window.location.href = '/thank-you.html?lp=sscamasa';
        return;
      }

      const msg = data?.message || 'OTP is wrong. Please try again.';
      setOtpError(msg);
      setOtpValues(['', '', '', '']);
      focusOtpFirst();
    } catch (err) {
      setOtpError('OTP is wrong. Please try again.');
      setOtpValues(['', '', '', '']);
      focusOtpFirst();
    } finally {
      setIsVerifyingOtp(false);
    }
  };

  const handleResendOtp = async () => {
    if (isResendingOtp) return;
    if (!token) return;
    if (resendCountdown > 0) return;

    setIsResendingOtp(true);
    setResendWaitMessage('');

    try {
      const res = await fetch(RESEND_OTP_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token })
      });

      const data = await res.json().catch(() => ({}));

      if (data?.success === true) {
        setOtpValues(['', '', '', '']);
        setResendCountdown(60);
        setResendWaitMessage('');
        setOtpError('');
        focusOtpFirst();
      } else {
        const waitSeconds = data?.wait_seconds || data?.waitSeconds;
        if (typeof waitSeconds === 'number' && waitSeconds > 0) {
          setResendCountdown(waitSeconds);
          setResendWaitMessage(`Please wait ${waitSeconds}s`);
        } else {
          setResendWaitMessage(data?.message || 'Please wait before retrying.');
        }
      }
    } catch (err) {
      setResendWaitMessage('Please wait before retrying.');
    } finally {
      setIsResendingOtp(false);
    }
  };

  const handleEditNumber = () => {
    setIsOtpStep(false);
    setToken('');
    setOtpValues(['', '', '', '']);
    setOtpError('');
    setIsVerifyingOtp(false);
    setIsResendingOtp(false);
    setResendCountdown(60);
    setResendWaitMessage('');
  };

  return (
    <>
      <section
        ref={targetSectionRef}
        className={`w-full flex flex-wrap ${
          layout === 'default' ? 'primary-bg py-lg-5 p-4' : 'bannerForm'
        }`}
        data-aos={`${isMobile ? 'fade-up' : layout === 'default' ? 'fade-in' : 'fade-left'}`}
        data-aos-offset={`${isMobile ? '50' : '100'}`}
        data-aos-duration={`${isMobile ? '300' : layout === 'default' ? '500' : '1000'}`}
        data-aos-once="true"
        data-aos-easing="ease-in-sine"
        data-aos-delay="0"
      >
        <Title
          secondHeading={
            layout === 'default'
              ? 'Call or fill the enquiry form to arrange a site visit.'
              : 'REQUEST A CALL BACK'
          }
          _secondHeading={'text-white'}
          _class={layout === 'default' ? 'mb-md-5 m-1' : 'mb-0'}
          style={titleStyle}
        />
        <div className={layout === 'default' ? 'col-lg-9 col-12 m-auto' : 'w-full'} style={formStyle}>
          {!isOtpStep ? (
            <form onSubmit={handleSubmit} autoComplete="off">
              <input type="hidden" name="lp_name" value={LP_NAME} />
              <div className="w-full flex align-items-center">
                <Box className="rowFormControl col-12 float-start d-flex md:gap-3 gap-2">
                  <TextField
                  fullWidth
                  label="FULL NAME"
                  name="name"
                  value={formValues.name}
                  onChange={handleChange}
                  margin="none"
                  variant="outlined"
                  required
                  autoComplete="off"
                  sx={{
                    input: {
                      color: layout === 'default' ? '#fff' : '#000',
                      fontFamily: layout === 'default' ? 'AvertaStd' : 'AvertaStd',
                      '&:-webkit-autofill': {
        borderRadius: layout === 'default' ? '0' : '15px',
      },
                    },
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        border: 0,
                        boxShadow: 'inherit',
                        borderRadius: layout === 'default' ? '0' : '15px',
                        borderBottom: layout === 'default' ? '1px solid #fff' : '1px solid #fff',
                        backgroundColor: layout === 'default' ? '' : '#fff',
                      },
                      '&:hover fieldset': {
                        borderBottom: layout === 'default' ? '1px solid #fff' : '1px solid #000',
                      },
                      '&.Mui-focused fieldset': {
                        borderBottom: layout === 'default' ? '1px solid #fff' : '1px solid #000',
                        outline: 'none',
                      },
                    },
                    '& .MuiInputLabel-root': {
                      color: layout === 'default' ? '#fff' : '#000',
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      color: layout === 'default' ? '#fff' : '#a37b0f',
                    },
                  }}
                  />
                  <TextField
                  fullWidth
                  label="MOBILE NO"
                  name="phone"
                  type="tel"
                  value={formValues.phone}
                  onChange={handleChange}
                  margin="none"
                  variant="outlined"
                  required
                  autoComplete="off"
                  sx={{
                    input: {
                      color: layout === 'default' ? '#fff' : '#000',
                      fontFamily: layout === 'default' ? 'AvertaStd' : 'AvertaStd',
                      '&:-webkit-autofill': {
        borderRadius: layout === 'default' ? '0' : '15px',
      },
                    },
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        border: 0,
                        boxShadow: 'inherit',
                        borderRadius: layout === 'default' ? '0' : '15px',
                        borderBottom: layout === 'default' ? '1px solid #fff' : '1px solid #fff',
                        backgroundColor: layout === 'default' ? '' : '#fff',
                      },
                      '&:hover fieldset': {
                        borderBottom: layout === 'default' ? '1px solid #fff' : '1px solid #000',
                      },
                      '&.Mui-focused fieldset': {
                        borderBottom: layout === 'default' ? '1px solid #fff' : '1px solid #000',
                        outline: 'none',
                      },
                    },
                    '& .MuiInputLabel-root': {
                      color: layout === 'default' ? '#fff' : '#000',
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      color: layout === 'default' ? '#fff' : '#a37b0f',
                    },
                  }}
                  />
                  <TextField
                  fullWidth
                  label="EMAIL ID"
                  name="email"
                  type="email"
                  value={formValues.email}
                  onChange={handleChange}
                  margin="none"
                  variant="outlined"
                  required
                  autoComplete="off"
                  sx={{
                    input: {
                      color: layout === 'default' ? '#fff' : '#000',
                      fontFamily: layout === 'default' ? 'AvertaStd' : 'AvertaStd',
                     '&:-webkit-autofill': {
        borderRadius: layout === 'default' ? '0' : '15px',
      },
                    },
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        border: 0,
                        boxShadow: 'inherit',
                        borderRadius: layout === 'default' ? '0' : '15px',
                        borderBottom: layout === 'default' ? '1px solid #fff' : '1px solid #fff',
                        backgroundColor: layout === 'default' ? '' : '#fff',
                      },
                      '&:hover fieldset': {
                        borderBottom: layout === 'default' ? '1px solid #fff' : '1px solid #000',
                      },
                      '&.Mui-focused fieldset': {
                        borderBottom: layout === 'default' ? '1px solid #fff' : '1px solid #000',
                        outline: 'none',
                      },
                    },
                    '& .MuiInputLabel-root': {
                      color: layout === 'default' ? '#fff' : '#000',
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      color: layout === 'default' ? '#fff' : '#a37b0f',
                    },
                  }}
                  />
                  <Fill
                  buttonText1={loading ? 'Submitting...' : 'Submit'}
                  buttonText2={loading ? 'Submitting...' : 'Submit'}
                  isSubmit={true}
                  _class={`text-white border md:w-[300px] m-md-0 mt-3 ${loading ? 'cursor-not-allowed' : ''}`}
                  disabled={loading} 
                  />
                </Box>
              </div>
              {submitError ? (
                <p className="text-red-200 text-center w-full mb-0 mt-2">
                  {submitError}
                </p>
              ) : null}
            </form>
          ) : (
            <div className="w-full flex flex-wrap">
              <div className="w-full text-center">
                <h3 className="text-white text-2xl font-semibold mb-2">Verify Your Mobile</h3>
                <p className="text-white text-center mb-4">Enter the 4-digit OTP sent to your mobile</p>

                <div className="flex items-center justify-center gap-3 mb-4">
                  <input
                    ref={otpInput0Ref}
                    className="otp-digit-input w-14 h-14 border border-[#a37b0f] rounded-lg text-center text-white text-2xl font-semibold bg-transparent focus:outline-none"
                    inputMode="numeric"
                    type="text"
                    value={otpValues[0]}
                    onChange={(e) => handleOtpDigitChange(0, e)}
                    onKeyDown={(e) => handleOtpKeyDown(0, e)}
                    onPaste={handleOtpPaste}
                    maxLength={1}
                    autoComplete="one-time-code"
                    aria-label="OTP digit 1"
                  />
                  <input
                    ref={otpInput1Ref}
                    className="otp-digit-input w-14 h-14 border border-[#a37b0f] rounded-lg text-center text-white text-2xl font-semibold bg-transparent focus:outline-none"
                    inputMode="numeric"
                    type="text"
                    value={otpValues[1]}
                    onChange={(e) => handleOtpDigitChange(1, e)}
                    onKeyDown={(e) => handleOtpKeyDown(1, e)}
                    onPaste={handleOtpPaste}
                    maxLength={1}
                    autoComplete="one-time-code"
                    aria-label="OTP digit 2"
                  />
                  <input
                    ref={otpInput2Ref}
                    className="otp-digit-input w-14 h-14 border border-[#a37b0f] rounded-lg text-center text-white text-2xl font-semibold bg-transparent focus:outline-none"
                    inputMode="numeric"
                    type="text"
                    value={otpValues[2]}
                    onChange={(e) => handleOtpDigitChange(2, e)}
                    onKeyDown={(e) => handleOtpKeyDown(2, e)}
                    onPaste={handleOtpPaste}
                    maxLength={1}
                    autoComplete="one-time-code"
                    aria-label="OTP digit 3"
                  />
                  <input
                    ref={otpInput3Ref}
                    className="otp-digit-input w-14 h-14 border border-[#a37b0f] rounded-lg text-center text-white text-2xl font-semibold bg-transparent focus:outline-none"
                    inputMode="numeric"
                    type="text"
                    value={otpValues[3]}
                    onChange={(e) => handleOtpDigitChange(3, e)}
                    onKeyDown={(e) => handleOtpKeyDown(3, e)}
                    onPaste={handleOtpPaste}
                    maxLength={1}
                    autoComplete="one-time-code"
                    aria-label="OTP digit 4"
                  />
                </div>

                {otpError ? (
                  <p className="text-red-200 text-center mb-3">{otpError}</p>
                ) : null}

                <div className="flex justify-center">
                  <Fill
                    buttonText1={isVerifyingOtp ? 'Verifying...' : 'Verify'}
                    buttonText2={isVerifyingOtp ? 'Verifying...' : 'Verify'}
                    isSubmit={true}
                    handleSubmit={handleVerifyOtp}
                    _class={`text-white border md:w-[300px] m-md-0 mt-3 ${isVerifyingOtp ? 'cursor-not-allowed' : ''}`}
                    disabled={isVerifyingOtp}
                  />
                </div>

                <div className="w-full mt-3">
                  {resendCountdown > 0 ? (
                    <p className="text-white text-center">
                      Resend OTP in {resendCountdown}s
                    </p>
                  ) : (
                    <button
                      type="button"
                      onClick={handleResendOtp}
                      className="text-white underline block text-center w-full"
                      disabled={isResendingOtp}
                    >
                      {isResendingOtp ? 'Resending...' : 'Resend OTP'}
                    </button>
                  )}
                  {resendWaitMessage ? (
                    <p className="text-red-200 text-center mt-2">{resendWaitMessage}</p>
                  ) : null}
                </div>

                <button
                  type="button"
                  onClick={handleEditNumber}
                  className="text-white underline mt-4"
                >
                  Edit number
                </button>
              </div>
            </div>
          )}
        </div>
      </section>
      <div
        className={`floatButton mobile-show ${
          isScroll ? 'show' : 'hide'
        } fixed transition-opacity duration-300`}
      >
        <div className="col-12 float-start w-full">
          <button
            className="btn-epic text-white border md:w-[300px] m-md-0 mt-3"
            aria-label="Scroll to top"
            onClick={scrollToSection}
          >
            <span>Request A Call Back</span>
            <span>Request A Call Back</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default BusinessEnquiry;
